<template>
   
    <div :class="open ? 'modal is-active modalZoom' : 'modal modalZoom' ">
        <div class="modal-background"></div>
    <div class="modal-card">
    <header class="modal-card-head" >
        <p class="modal-card-title" style="width:90%" > Préférence de zoom :</p>	
        <div style="float:rigth" >
            <s-button theme="" label="" icon="times-circle" @onclick="$emit('close')"/>
        </div>
    </header>
    <section class="modal-card-body">
    <div style="width: 100%">
            
            
            <s-button theme="is-large is-info" label="Zoom 50%" @onclick="setZoom(50)"/><br/><br/>
            <s-button theme="is-large is-info " label="Zoom 75%" @onclick="setZoom(75)"/><br/><br/>
            <s-button theme="is-large is-info"  label="Zoom 100%" @onclick="setZoom(100)"/><br/><br/>
            <s-button theme="is-large is-info"  label="Zoom 150%" @onclick="setZoom(150)"/><br/><br/>
            
     </div>
    </section>
    </div>
    </div>
   
</template>
<style  scoped>
    
</style>
<script>

  export default {
    props:["open"],
    
    methods: {
        setZoom(value) {
            document.body.style.zoom = value + "%";
            this.$emit("close");
        }
    }
    
  }
</script>